import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        VRow,
        { staticClass: "mt-0", attrs: { "no-gutters": "" } },
        [
          _c(VSpacer),
          _c(
            VCol,
            { attrs: { cols: "4" } },
            [
              _c("app-select-mapeamento", {
                attrs: {
                  mapeamento: _vm.mapeamento,
                  mapeamentos: _vm.mapeamentos,
                },
                on: { return: (value) => (_vm.mapeamento = value) },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        VRow,
        { attrs: { "no-gutters": "" } },
        [
          _c(
            VCol,
            { attrs: { cols: "12" } },
            [
              _c("v-card-widget", { attrs: { title: "Informações" } }, [
                _c(
                  "div",
                  { attrs: { slot: "widget-content" }, slot: "widget-content" },
                  [
                    _c(
                      VRow,
                      { attrs: { "no-gutters": "" } },
                      [
                        _c(VCol, { attrs: { cols: "6" } }, [
                          _c("span", { staticClass: "font-weight-bold" }, [
                            _vm._v("Mapeamento: "),
                          ]),
                          _c("span", { staticClass: "font-weight-light" }, [
                            _vm._v(
                              _vm._s(
                                _vm.mapeamento && _vm.mapeamento.nome
                                  ? _vm.mapeamento.nome
                                  : ""
                              )
                            ),
                          ]),
                        ]),
                        _vm.inicio && _vm.fim
                          ? _c(VCol, { attrs: { cols: "6" } }, [
                              _c("span", { staticClass: "font-weight-bold" }, [
                                _vm._v("Período: "),
                              ]),
                              _c("span", { staticClass: "font-weight-light" }, [
                                _vm._v(
                                  _vm._s(_vm._f("date")(_vm.inicio)) +
                                    " até " +
                                    _vm._s(_vm._f("date")(_vm.fim))
                                ),
                              ]),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm.acesso !== "COMISSAO"
                      ? _c(
                          VRow,
                          { attrs: { "no-gutters": "" } },
                          [
                            _vm.servidor && _vm.chefia
                              ? _c(VCol, { attrs: { cols: "6" } }, [
                                  _c(
                                    "span",
                                    { staticClass: "font-weight-bold" },
                                    [_vm._v("Gestor(a): ")]
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "font-weight-light" },
                                    [_vm._v(_vm._s(_vm.servidor))]
                                  ),
                                ])
                              : _vm.servidor
                              ? _c(VCol, { attrs: { cols: "6" } }, [
                                  _c(
                                    "span",
                                    { staticClass: "font-weight-bold" },
                                    [_vm._v("Servidor(a): ")]
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "font-weight-light" },
                                    [_vm._v(_vm._s(_vm.servidor))]
                                  ),
                                ])
                              : _vm._e(),
                            _vm.unidade && _vm.unidade.sigla
                              ? _c(VCol, { attrs: { cols: "6" } }, [
                                  _c(
                                    "span",
                                    { staticClass: "font-weight-bold" },
                                    [_vm._v("Unidade: ")]
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "font-weight-light" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.unidade.sigla) +
                                          " - " +
                                          _vm._s(_vm.unidade.nome)
                                      ),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        VRow,
        [
          _c(
            VCol,
            { attrs: { cols: "12" } },
            [
              _c(
                "v-card-widget",
                {
                  attrs: {
                    "enable-actions": !_vm.prazoEsgotado && !_vm.prazoFuturo,
                    title: _vm.titulo ? _vm.titulo : "Formulário",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      attrs: { slot: "widget-content" },
                      slot: "widget-content",
                    },
                    [
                      _c(
                        VTooltip,
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u([
                            {
                              key: "activator",
                              fn: function ({ on }) {
                                return [
                                  _c(
                                    VBtn,
                                    _vm._g(
                                      {
                                        attrs: {
                                          absolute: "",
                                          color: "secondary",
                                          dark: "",
                                          fab: "",
                                          right: "",
                                          top: "",
                                        },
                                        on: { click: _vm.loadTutorial },
                                      },
                                      on
                                    ),
                                    [_c(VIcon, [_vm._v("help")])],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                        },
                        [
                          _c("span", [
                            _vm._v("Em caso de dúvidas, clique aqui"),
                          ]),
                        ]
                      ),
                      _vm.prazoEsgotado &&
                      _vm.usuarioMapeamento &&
                      _vm.usuarioMapeamento.tipo == "REGULAR"
                        ? _c(
                            VRow,
                            { attrs: { "no-gutters": "" } },
                            [
                              _c(
                                VCol,
                                [
                                  _c("app-alert", {
                                    attrs: {
                                      icon: "watch_later",
                                      message:
                                        "O prazo para participação está esgotado. Obrigado pela sua colaboração.",
                                      type: "warning",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.prazoFuturo &&
                      _vm.usuarioMapeamento &&
                      _vm.usuarioMapeamento.tipo == "REGULAR"
                        ? _c(
                            VRow,
                            { attrs: { "no-gutters": "" } },
                            [
                              _c(
                                VCol,
                                [
                                  _c("app-alert", {
                                    attrs: {
                                      icon: "watch_later",
                                      message:
                                        "O prazo para participação ainda não está disponível.",
                                      type: "info",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      !_vm.mapeamento
                        ? _c(
                            VRow,
                            { attrs: { "no-gutters": "" } },
                            [
                              _c(
                                VCol,
                                [
                                  _c("app-alert", {
                                    attrs: {
                                      message:
                                        "Não há nenhum mapeamento disponível para realização da dinâmica.",
                                      type: "warning",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        VRow,
                        { attrs: { "no-gutters": "" } },
                        [_c(VCol, [_vm._t("body")], 2)],
                        1
                      ),
                    ],
                    1
                  ),
                  !_vm.prazoEsgotado && !_vm.prazoFuturo
                    ? _c(
                        "div",
                        {
                          attrs: { slot: "widget-actions" },
                          slot: "widget-actions",
                        },
                        [
                          _c(
                            VRow,
                            { attrs: { "no-gutters": "" } },
                            [
                              _c(
                                VCol,
                                { attrs: { cols: "12" } },
                                [_vm._t("actions")],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }